<template>
  <div>
    <div class="details-component__header">
        <span>
          <h1>{{ $t('payment.card_registration_result') }}</h1>
        </span>
    </div>
    <div v-if="regSuccessMessage">
      <h2 class="successMessage">{{ $t('payment.card_added') }}</h2>
      <div class="form__buttons buttonset" style="justify-content: left !important; margin-top: 30px">
        <router-link to="/" class="buttonset__button btn btn--secondary active">
          {{ $t('payment.start_parking') }}
        </router-link>
        <router-link to="/payment" class="navbar__item link">
          <button type="submit" class="buttonset__button btn btn--main">
            {{ $t('payment.list') }}
          </button>
        </router-link>
      </div>
    </div>
    <div v-else-if="regErrorMessage">
      <h2 class="errorMessage">{{ $t('payment.card_not_added') }}</h2>
      <div class="form__buttons buttonset" style="justify-content: left !important; margin-top: 30px">
        <router-link to="/payment" class="navbar__item link">
          <button type="submit" class="buttonset__button btn btn--main">
            {{ $t('payment.try_again') }}
          </button>
        </router-link>
      </div>
    </div>
    <div v-else class="loader-bubbles"></div>
  </div>

</template>

<script>
import WarningModal from './../../common/WarningModal'
import {mapGetters} from "vuex";

export default {
  components: {
    WarningModal
  },
  mounted() {
    if (this.checkResponseData() && !this.inProgress) {
      this.$store.dispatch('payment/cards/setInProgress', true)
      this.storeCard(this.$route.query.transactionId)
    }
  },
  computed: {
    ...mapGetters({
      inProgress: 'payment/cards/inProgress',
      regSuccessMessage: 'payment/cards/regSuccessMessage',
      regErrorMessage: 'payment/cards/regErrorMessage'
    }),
  },
  methods: {
    checkResponseData() {
      return !(!this.$route.query.transactionId || !this.$route.query.responseCode);
    },
    storeCard(transactionId) {
      this.$store.dispatch('payment/cards/storeCard', {
        transactionId: transactionId
      }).then(success => {
        if (success) {
          this.$store.dispatch('payment/cards/setRegResultMessage', {
            success: true,
            message: 'payment.card_added'
          })
        } else {
          this.$store.dispatch('payment/cards/setRegResultMessage', {
            success: false,
            message: 'payment.card_not_added'
          })
        }
        this.$store.dispatch('payment/cards/setInProgress', false)
      })
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../../styles/_spinner.scss';
@import '../assets/styles/payment';

.successMessage {
  color: var(--brand-green)
}

.errorMessage {
  color: var(--brand-red)
}

</style>



// WEBPACK FOOTER //
// src/components/payment/features/RegistrationResult.vue